
interface FileDownloadReturn {
  downloadFile: (url: string, fileName: string, options?: {
    onSuccess?: () => void,
    onError?: (error: Error) => void,
    closeDialog?: () => void
  }) => Promise<void>
}

/**
 * A reusable hook for downloading files from URLs.
 * 
 * @returns Object with downloadFile function
 */
const useFileDownload = (): FileDownloadReturn => {

  const downloadFile = async (
    url: string, 
    fileName: string, 
    options?: {
      onSuccess?: () => void,
      onError?: (error: Error) => void,
      closeDialog?: () => void
    }
  ): Promise<void> => {
    if (!url || !fileName) return
    
    
    try {
      // Fetch the file from the provided URL
      const response = await fetch(url)

      if (!response.ok) {
        throw new Error('File download failed')
      }

      // Convert the response into a Blob
      const blob = await response.blob()

      // Create a URL for the Blob
      const objectUrl = window.URL.createObjectURL(blob)

      // Create a temporary anchor element
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = fileName

      // Append the anchor to the DOM
      document.body.appendChild(a)

      // Programmatically click the anchor to trigger the download
      a.click()

      // Clean up
      document.body.removeChild(a)
      window.URL.revokeObjectURL(objectUrl)
      
      // Call the success callback if provided
      if (options?.onSuccess) options.onSuccess()
      
    } catch (error) {
      console.error('Download failed', error)
      if (options?.onError && error instanceof Error) options.onError(error)
    } finally {
      if (options?.closeDialog) options.closeDialog()
    }
  }

  return {
    downloadFile,
  }
}

export default useFileDownload